import { render, staticRenderFns } from "./extra_info.vue?vue&type=template&id=25c6bc34"
import script from "./extra_info.vue?vue&type=script&lang=js"
export * from "./extra_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports